<template>
  <v-container fluid fill-height style="padding: 0; margin: 0">
    <v-snackbar top color="error" v-model="snackbar.model">{{
      snackbar.msg
    }}</v-snackbar>

    <v-row style="height: 100%" no-gutters>
      <!-- >= md screen -->
      <v-col cols="12" class="d-none d-md-block">
        <v-row style="height: 100%" no-gutters>
          <Column>
            <!-- create account form -->
            <template v-slot:nav>
              <v-btn
                text
                @click.prevent="toggleForm"
                class="mr-2"
                v-bind="btnProps"
                >Sign In</v-btn
              >
              <v-btn class="primary" v-bind="btnProps">Request Demo</v-btn>
            </template>
            <template v-slot:title>Create Account</template>

            <CreateAccount @authError="showSnackbar" />
            <template v-slot:footer
              ><router-link
                :to="{ name: 'LogIn' }"
                style="text-decoration: underline"
                >Vote</router-link
              >
              instead?</template
            >
          </Column>

          <Column>
            <!-- sign in form -->
            <template v-slot:nav>
              <v-btn
                text
                @click.prevent="toggleForm"
                class="mr-2"
                v-bind="btnProps"
                >Sign Up</v-btn
              >
              <v-btn class="primary" v-bind="btnProps">Request Demo</v-btn>
            </template>
            <template v-slot:title>Sign In</template>

            <SignIn @authError="showSnackbar" />
            <template v-slot:footer
              ><router-link
                :to="{ name: 'LogIn' }"
                style="text-decoration: underline"
                >Vote</router-link
              >
              instead?</template
            >
          </Column>

          <v-col
            cols="6"
            class="slide d-flex justify-center align-center flex-column"
            :class="`${isSignIn ? 'slide-left' : 'slide-right'}`"
          >
            <Logo :width="195" :filename="`logo-white.svg`" />
          </v-col>
        </v-row>
      </v-col>
      <!-- end: >= md screen -->

      <!-- < md screen -->
      <v-col
        cols="12"
        class="d-block d-md-none gradient-bg"
        style="color: white"
      >
        <v-row justify="center" no-gutters>
          <v-col cols="12" class="mx-auto d-flex justify-center mt-12 mb-6">
            <div>
              <Logo :width="180" :filename="`logo-white.svg`" />
            </div>
          </v-col>

          <v-col cols="12" md="4">
            <v-card class="mx-auto pa-8" style="width: 90%">
              <v-list-item class="text-center">
                <v-list-item-content>
                  <v-list-item-title class="mb-3">
                    <h2 style="color: #1b3665">{{ titleLink[0] }}</h2>
                  </v-list-item-title>
                  <p>
                    <span
                      @click.prevent="toggleForm"
                      style="text-decoration: underline; cursor: pointer"
                      >{{ titleLink[1] }}</span
                    >
                    instead?
                  </p>
                </v-list-item-content>
              </v-list-item>

              <SignIn v-if="isSignIn" @authError="showSnackbar" />
              <CreateAccount v-else @authError="showSnackbar" />
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <!-- end: < md screen -->
    </v-row>
  </v-container>
</template>

<script>
import { SignIn, CreateAccount } from "@/components/organizer";
import Column from "@/components/Column.vue";
import Logo from "@/components/Logo.vue";
import { btnProps } from "@/helpers";

export default {
  components: {
    SignIn,
    CreateAccount,
    Logo,
    Column,
  },

  data: () => ({
    btnProps,
    isSignIn: true,

    snackbar: {
      model: false,
      msg: "Error!",
    },
  }),

  computed: {
    titleLink() {
      if (this.isSignIn) return ["Sign In", "Create Account"];
      else return ["Create Account", "Sign In"];
    },

    brandName() {
      return process.env.VUE_APP_BRAND_NAME;
    },
  },

  methods: {
    toggleForm() {
      this.isSignIn = !this.isSignIn;
    },

    showSnackbar(event) {
      this.snackbar.msg = event.msg;
      this.snackbar.model = true;
    },
  },
};
</script>

<style scoped>
.gradient-bg {
  background-image: linear-gradient(#005cff, #2d9bfc, #3de0ff);
  background-size: cover;
}

.slide {
  height: 100%;
  background-image: url("~@/assets/images/logomark-pattern-white.png"),
    /* linear-gradient(#005cff, #2d9bfc, #3de0ff); */
      linear-gradient(#3de0ff, #2d9bfc, #005cff);

  background-size: cover;
  z-index: 1;
  position: absolute;
  left: 0;
}

.slide-right {
  animation: slideRight 0.5s forwards;
}

.slide-left {
  animation: slideLeft 0.5s forwards;
}

@keyframes slideRight {
  from {
    transform: translateX(0);
  }

  to {
    transform: translateX(100%);
  }
}

@keyframes slideLeft {
  from {
    transform: translateX(100%);
  }

  to {
    transform: translateX(0);
  }
}
</style>
